import Debug from 'debug'
import { delay } from './delay'
const debug = Debug('jotta:download')

export async function formDownload(
  url: string,
  data: { [key: string]: string },
) {
  const form = document.createElement('form')
  form.action = url
  form.method = 'POST'
  form.style.display = 'none'
  for (const [key, value] of Object.entries(data)) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = value
    form.appendChild(input)
  }
  document.body.appendChild(form)

  debug('form download', form.target, url, data, form)
  form.submit()

  await delay(500)
  document.body.removeChild(form)
}

export function downloadBlob(blob: Blob, name: string) {
  const a = document.createElement('a')
  const url = URL.createObjectURL(blob)
  a.href = url
  a.download = name || 'download'

  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url)
      a.removeEventListener('click', clickHandler)
    }, 150)
  }
  a.addEventListener('click', clickHandler, false)
  a.click()
}
